import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { getProfile, Root as RootProfile } from 'services/get-profile'

interface MetadataUser {
  profile: RootProfile | null
  darkMode: boolean | null
  setDarkMode: React.Dispatch<React.SetStateAction<boolean | null>>
}

const metadataUserContext = createContext<MetadataUser>({} as MetadataUser)

type MetadataUserProps = {
  children: ReactNode
}

export const MetadataUserProvider = ({ children }: MetadataUserProps) => {
  const [profile, setProfile] = useState<RootProfile | null>(null)
  const [darkMode, setDarkMode] = useState<boolean | null>(false)

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profile = await getProfile()
        setProfile(profile)
      } catch (error) {
        setProfile(null)
      }
    }

    fetchProfile()
  }, [])

  return useMemo(
    () => (
      <metadataUserContext.Provider
        value={{
          profile,
          darkMode,
          setDarkMode,
        }}
      >
        {children}
      </metadataUserContext.Provider>
    ),
    [profile, darkMode, children],
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useMetadataUser = () => {
  const context = useContext(metadataUserContext)
  return context
}
